import { useAuthStore } from "@/stores/auth";

type AdminStatus = "admin" | "non-admin" | "unknown";

export function useIsAdmin(): AdminStatus {
  const xperisusUser = useAuthStore((s) => s.xperisusUser);
  if (!xperisusUser) return "unknown";
  const roles = xperisusUser.role_types;
  if (!Array.isArray(roles)) return "non-admin";
  return roles.includes("admin") ? "admin" : "non-admin";
}
